import Color from './color'
import _get from 'lodash/get'
import _isObjectLike from 'lodash/isObjectLike'

// Graphic
export default class {
  constructor (config = {}) {
    this.manifest = {}
    // Guard on truthiness: a saved design can carry more graphics than the
    // product manifest declares, in which case the manifest lookup yields
    // undefined. hasOwnProperty would still be true and clobber the {} default,
    // leaving graphic.manifest undefined and breaking render (RBI-WEBSITE-5Z6).
    if (config.manifest) {
      this.manifest = config.manifest
    }

    this.areaIndex = null
    this.areaLabel = ''
    this.textIndex = null
    this.graphicIndex = null
    this._path = null
    this.isRelational = null
    this.relationalGraphicKey = null
    this.category = null
    this.position = ''
    this.label = ''
    this.image = null
    this.zone = 1
    this.objName = ''
    this.colorFill = false
    this.custom = false

    let defaults = {}
    try {
      defaults = config.defaults
    } finally {}

    if (config.hasOwnProperty('graphicObj')) {
      this.fromObject(config.graphicObj, defaults)
    }
  }

  fromObject (graphicObj, defaults) {
    // Required fields
    this.areaIndex = graphicObj.areaIndex
    if (typeof this.areaIndex === 'undefined') {
      this.areaIndex = graphicObj.areas_index
    }

    this.areaLabel = graphicObj.areaLabel

    this.isRelational = graphicObj.isRelational
    this._path = `customization.areas.${this.areaIndex}`

    if (typeof graphicObj.textIndex !== 'undefined') {
      this.textIndex = _get(graphicObj, 'textIndex')
      if (typeof this.textIndex === 'undefined') {
        this.textIndex = _get(graphicObj, 'texts_index')
      }
      this.graphicIndex = _get(graphicObj, 'graphicIndex')
      if (typeof this.graphicIndex === 'undefined') {
        this.graphicIndex = _get(graphicObj, 'graphics_index')
      }
      this._path += `.texts.${this.textIndex}.${this.graphicIndex}`
    } else {
      this.graphicIndex = _get(graphicObj, 'graphicIndex')
      this._path += `.graphics.${this.graphicIndex}`
    }

    try {
      this.image = graphicObj.image
    } finally {}

    try {
      this.relationalGraphicKey = graphicObj.relationalGraphicKey
    } finally {}

    try {
      this.category = graphicObj.category
    } finally {}

    try {
      this.position = graphicObj.position
    } finally {}

    try {
      this.label = graphicObj.label
    } finally {}

    try {
      this.zone = graphicObj.zone
    } finally {}

    try {
      this.objName = graphicObj.objName
    } finally {}

    let recommendedPath = `${this._path}.colorFill`
    let colorConfig = {
      _path: recommendedPath
    }
    let defaultPrintColor = _get(defaults, 'printColor')
    if (defaultPrintColor) {
      Object.assign(colorConfig, defaultPrintColor)
    }

    let defaultColorConfig = _get(graphicObj, 'colorFill', null)
    if (defaultColorConfig) {
      if (_isObjectLike(defaultColorConfig) && _get(defaultColorConfig, 'id')) {
        colorConfig = defaultColorConfig
        if (!_get(colorConfig, '_path')) {
          colorConfig._path = recommendedPath
        }
      }
    }
    this.colorFill = new Color(colorConfig)

    try {
      this.custom = graphicObj.custom
    } finally {}
  }

  getPostData () {
    let me = {
      'label': this.label,
      'image': this.image,
      'custom': this.custom,
      'colorFill': this.colorFill,
      'width': this.width,
      'height': this.height,
      'position': this.position,
      'zone': this.zone,
      'objName': this.objName,
      'category': this.category,
      'areas_index': this.areaIndex,
      'graphics_index': this.graphicIndex,
      'areaLabel': this.areaLabel,
      'isRelational': this.isRelational
    }

    if (this.textIndex) {
      me.texts_index = this.textIndex
    }

    if (this.relationalGraphicKey) {
      me.relationalGraphicKey = this.relationalGraphicKey
    }

    return me
  }
}
